<div
  class="sidebar"
  [ngClass]="collapsed ? 'sidebar-collapsed' : ''"
  (click)="toggleCoppalse($event)"
>
  <div class="side-container">
    <div class="logo-container" #popup>
      <img
        src="/assets/icons/svg/sidebar/binariks-logo.svg"
        class="main-logo"
        alt="main-logo"
        (click)="showPopup = !showPopup"
      />
      <div class="logo-text" *ngIf="collapsed">binariks</div>
      <div
        class="logo-popup"
        *ngIf="showPopup"
        [ngStyle]="{left: collapsed ? '34%' : '67%'}"
      >
        <ul>
          <li>
            <a class="logo-link">Web Internal Tool</a>
          </li>
          <li>
            <a class="logo-link" [href]="timeTrackingUrl">Time Tracking Tool</a>
          </li>
          <li>
            <a class="logo-link" href="http://portal.binariks.com/">Portal</a>
          </li>
        </ul>
      </div>
    </div>
    <ul class="sidebar__nav">
      <ng-container *ngFor="let data of sidebarData">
        <li class="sidebar__nav-item" *ngIf="data.display">
          <a
            class="sidebar__nav-link"
            [routerLink]="[data.routeLink]"
            routerLinkActive="active"
            uiTooltip
            [tTooltip]="data.text"
            [tooltipDisabled]="collapsed"
          >
            <img
              [src]="'/assets/icons/svg/sidebar/' + data.imgSrc"
              alt="logo"
              class="sidebar__nav-icon"
              [class.notification]="
                data.text === 'Notifications' && count ? true : null
              "
            />
            <span
              *ngIf="count && data.text === 'Notifications'"
              class="bell_icon"
              >{{ count }}
            </span>
            <span class="sidebar__nav-text" *ngIf="collapsed">{{
              data.text
            }}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
  <div class="flex-footer" [class.active]="collapsed">
    <div
      class="flex-arrow"
      uiTooltip
      [tTooltip]="'Expand'"
      (click)="collapsed = !collapsed"
    >
      <img src="/assets/icons/svg/sidebar/sidebar-arrow.svg" />
    </div>
    <button class="btn__log-out" (click)="logout()">Logout</button>
  </div>
</div>
